<template>
  <div class="login">
    <div class="loginContent">
      <div class="loginTop">
        <h2>华西重症专科联盟网络平台</h2>
        <div class="cloud1">
          <img
            src="../assets/cloud1.png"
            alt=""
          >
        </div>
        <div class="cloud2">
          <img
            src="../assets/cloud2.png"
            alt=""
            width="54"
            height="32"
          >
        </div>
        <div class="cloud3">
          <img
            src="../assets/cloud3.png"
            alt=""
            width="23"
            height="16"
          >
        </div>
      </div>
      <div class="loginForm">
        <form>
          <input
            v-model="ruleForm.loginName"
            type="text"
            placeholder="账号"
            @keyup.enter.native="keyLogin($event)"
          >
          <input
            v-model="ruleForm.passwords"
            type="password"
            placeholder="密码"
            @keyup.enter.native="keyLogin($event)"
          >
          <button type="button" @click="login">登录</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
export default {
  created() {
    // localStorage.setItem("selected", "会诊");
    const query = this.GetQueryString("msg");
    const code = this.GetQueryString("code")
    // console.log('code', code)
    localStorage.setItem('code', code)
    // console.log('query', query)
    if (query != null && query.toString().length > 0) {
      Toast({
        message: query,
        position: "top",
        duration: 1500
      });
    }
  },
  data() {
    return {
      browserUrl: "",
      ruleForm: {
        loginName: "",
        passwords: ""
      }
    };
  },
  methods: {
    // enter键登录
    keyLogin(e) {
      this.login();
    },
    getUserMenu(userId) {
      this.Axios.get('/api/User/GetUserJurisdiction/'+ userId).then(res=>{
        if(res.data.data != 'undefined' && res.data.data.length > 0){
          for (let item of res.data.data) {
            if (item.menuName == '远程会诊') {
              localStorage.setItem('selected', '会诊')
              this.$router.push({
                name: "Consultation"
              })
            }
          }
        } else {
          Toast({
            message: "首次登录请先去pc端修改密码!",
            position: "top",
            duration: 1500
          });
        }
      })
    },
    login() {
      const code = this.GetQueryString('code')
      // console.log(111, code)
      if (this.ruleForm.loginName == "") {
        Toast({
          message: "请输入账号!",
          position: "top",
          duration: 1500
        });
        return;
      }
      if (this.ruleForm.passwords == "") {
        Toast({
          message: "请输入密码!",
          position: "top",
          duration: 1500
        });
        return;
      }
      Indicator.open("加载中...");
      let query = {
        loginName: this.ruleForm.loginName,
        passwords: this.ruleForm.passwords,
        code: code
      };
      this.Axios.get(
        "/api/User/UserLoginWeChat",
        { params: query },
        { timeout: 5000 }
      ) 
        .then(res => {
          //登录
          if (res.data.result.status === 100) {
            Indicator.close();
            let backInfo = res.data;
            const userId = res.data.result.userID
            localStorage.setItem("UserId", res.data.result.userID);
            localStorage.setItem("HospitalID", backInfo.result.hospitalId);
            this.getUserMenu(userId)
          } else {
            Indicator.close();
            Toast({
              message: res.data.result.message,
              position: "top",
              duration: 1500
            });
          }
        })
        .catch(error => {
          Indicator.close();
          Toast({
            message: '网络错误!',
            position: "top",
            duration: 1500
          });
        });
      return false
    },
    // 获取浏览器地址栏参数
    GetQueryString(paraName) {
      let url = document.location.toString();
      let arrObj = url.split("?");
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split("&");
        let arr
        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paraName) {
            return arr[1]
          }
        }
        return null
      } else {
        return null
      }
    }
  }
};
</script>

<style lang="less">
.login {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  .loginContent {
    margin: 1%;
    box-shadow: 0 3px 16px -5px #070707;
    border-radius: 4px;
    width: 500px;
    height: 555px;
    background: white;
    position: relative;
    .loginTop {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      height: 312px;
      width: 100%;
      border-radius: 4px;
      background: url("../assets/login-bghx.jpg") no-repeat;
      background-size: 100% 100%;
      position: relative;
      h2 {
        color: white;
        // width: 288px;
        text-align: center;
        height: 31px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
      .cloud1 {
        width: 100%;
        height: 40px;
        margin-bottom: -70px;
        margin-top: -70px;
        img {
          position: relative;
          top: 0;
          left: 0px;
          animation: cloud1 8s linear infinite;
        }
      }
      .cloud2 {
        width: 100%;
        height: 32px;
        margin-bottom: -50px;
        margin-top: -70px;
        img {
          position: relative;
          top: 0;
          left: 0px;
          animation: cloud2 12s linear infinite;
        }
      }
      .cloud3 {
        width: 100%;
        height: 30px;
        margin-top: -50px;
        img {
          position: relative;
          top: 0;
          left: 0px;
          animation: cloud3 10s linear infinite;
        }
      }
    }
    .loginForm {
      width: 100%;
      height: 180px;
      margin-top: 20px;
      input {
        outline: none;
        border: 1px solid #e5e5e5;
        width: 72%;
        padding: 0 15px;
        height: 48px;
        line-height: 50px;
        font-size: 13px;
        margin: 0 auto 15px;
        border-radius: 5px;
        display: block;
        background: white;
        box-shadow: 0 0 0px 1000px white inset;
      }
      button {
        width: 80%;
        height: 50px;
        border-radius: 5px;
        color: white;
        background: #50e3ce;
        margin: 0 auto 15px;
        border: none;
        display: block;
        cursor: pointer;
        outline: none;
        &:hover {
          background: #73e9d8;
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: #666 !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: #666 !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: #666 !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
@keyframes cloud1 {
  from {
    left: 680px;
  }
  to {
    left: -50px;
  }
}
@keyframes cloud2 {
  from {
    left: 600px;
  }
  to {
    left: -50px;
  }
}
@keyframes cloud3 {
  from {
    left: 640px;
  }
  to {
    left: -50px;
  }
}
</style>
